import { SourceType } from "./common";

export enum TruckPlateColor {
  Blue = 0,
  Yellow = 1,
  Black = 2,
  White = 3,
  Green = 4,
}

export const getTruckPlateColorLabel = (plateColor?: number) => {
  switch (plateColor) {
    case TruckPlateColor.Blue:
      return "蓝色";
    case TruckPlateColor.Yellow:
      return "黄色";
    case TruckPlateColor.Black:
      return "黑色";
    case TruckPlateColor.White:
      return "白色";
    case TruckPlateColor.Green:
      return "绿色";
    default:
      return "未知";
  }
};

export enum TruckLength {
  L4_2 = "4.2米",
  L6_8 = "6.8米",
  L9_6 = "9.6米",
  L13 = "13米",
  L17_5 = "17.5米",
  L8_7 = "8.7米",
  L13_75 = "13.75米",
}

export enum TruckType {
  PingBan = "平板",
  GaoLan = "高栏",
  XiangShi = "厢式",
  ZiXie = "自卸",
  LengCang = "冷藏",
  PaTi = "爬梯",
  JiZhuangXiang = "集装箱",
  GaoDiBan = "高低板",
}

export interface IMSTruck {
  model: string;
  licensePlate: string;
  plateColor: TruckPlateColor;
  truckType: TruckType;
  truckLength: TruckLength;
  source: SourceType;
  drivers: string[];
}

export interface TruckVerifyInfo {
  id: string;
  of: string;
  vin: string;
  status: number;
  createdAt: string;
  updatedAt: string;
  __v: number;
  comment: string;
  image_list: string[] | null;
  name: string;
  remark: string;
  model: {
    meta: {
      merchant_id: string;
      account_id: string;
      created_at: string;
      updated_at: string;
      status: boolean;
      access_level: number;
    };
    context: Record<string, unknown>;
  };
  truck: {
    _id: string;
    plate: string;
    plate_color: number;
    type: string;
    truck_type: number;
    truck_length: number;
    user: string[];
    owner: string;
    verified: boolean;
    createdAt: string;
    updatedAt: string;
    __v: number;
    UpdatedAt: string;
    fee: number;
    model: {
      meta: {
        merchant_id: string;
        account_id: string;
        created_at: string;
        updated_at: string;
        status: boolean;
        access_level: number;
      };
      context: Record<string, unknown>;
    };
    phone: string;
  };
  plate: string;
}
